import { createContext } from 'react';

import { CockpitContextProviderProps } from './CockpitContextProvider.types';

export const CockpitContextProviderContext = createContext<CockpitContextProviderProps | undefined>(undefined);
